import { SVGProps } from 'react';

const MapPinPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.914 11.105A7 7 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0q.419-.361.824-.738M16 18h6m-3-3v6m-4-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default MapPinPlus;
